export const compareStrings = (str1: string = '', str2: string = '') =>
	str1.toLowerCase().includes(str2.toLowerCase());
